import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalService {
  public authenticationToken = '';
  publisherActive = true;
  public cmsToken = '';
}
